import { setCoreDependencies } from '@pn/core/dependencies';
import { pnTokenManager } from '@pn/core/services/authentication/tokenManager';
import { appActions } from '@pn/core/storage';
import { useAuthenticationService } from '@pn/services/authentication';
import { appSignalErrorLogger } from '@pn/services/loggers/appSignalErrorLogger';
import { map } from '@pn/services/map';
import { notificationService } from '@pn/services/notifications';
import React from 'react';
import { store } from 'src/application/storage/store';

function useInitializeApp() {
  const { getAccessToken } = useAuthenticationService();

  return () => {
    setCoreDependencies({
      appName: 'intel',
      errorLogger: appSignalErrorLogger,
      notificationService,
      map,
      store,
    });

    pnTokenManager.set(getAccessToken);
    appActions().initializeApp();
  };
}

export function useAutoInitializeApp(isAppInitialized: boolean) {
  const initializeApp = useInitializeApp();

  React.useEffect(() => {
    if (!isAppInitialized) {
      initializeApp();
    }
  }, [isAppInitialized, initializeApp]);
}
